export default "__VITE_PUBLIC_ASSET__1986bec1__"